import _jsx from "@babel/runtime/helpers/jsx";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _dec, _class, _class2;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { defineMessages, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Tooltip from '@mui/material/Tooltip';
import s from './EnhancedTableHead.scss';
import intlPropTypes from '../../constants/intlPropTypes';
var messages = defineMessages({
  sortTitle: {
    id: "EnhancedTableHead.sortTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Sort"
    }]
  }
});
var EnhancedTableHead = (_dec = withStyles(s), _dec(_class = injectIntl(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(EnhancedTableHead, _React$Component);
  var _super = _createSuper(EnhancedTableHead);
  function EnhancedTableHead() {
    var _this;
    _classCallCheck(this, EnhancedTableHead);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "createSortHandler", function (property) {
      return function (event) {
        _this.props.onRequestSort(event, property);
      };
    });
    return _this;
  }
  _createClass(EnhancedTableHead, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        order = _this$props.order,
        orderBy = _this$props.orderBy,
        columnData = _this$props.columnData,
        classNameHead = _this$props.classNameHead,
        classesNameRow = _this$props.classesNameRow,
        classesSortLabel = _this$props.classesSortLabel,
        loading = _this$props.loading,
        formatMessage = _this$props.intl.formatMessage;
      return /*#__PURE__*/_jsx(TableHead, {
        className: classNameHead
      }, void 0, /*#__PURE__*/_jsx(TableRow, {
        classes: classesNameRow
      }, void 0, columnData.map(function (column) {
        return /*#__PURE__*/_jsx(TableCell, {
          className: column.cellClassName,
          classes: {
            root: s.generalStylesCell
          },
          align: column.numeric ? 'right' : 'inherit',
          padding: column.disablePadding ? 'none' : 'default',
          sortDirection: !column.disableSorting && orderBy === column.id ? order : false,
          style: _.pickBy(column, function (val, key) {
            return ['minWidth', 'width'].includes(key) && val;
          })
        }, column.id, /*#__PURE__*/_jsx(Tooltip, {
          title: column.tooltip || (column.disableSorting ? column.label : formatMessage(messages.sortTitle)),
          placement: column.numeric ? 'bottom-end' : 'bottom-start',
          enterDelay: 300
        }, void 0, /*#__PURE__*/_jsx("div", {}, void 0, column.disableSorting && !column.child && /*#__PURE__*/_jsx(TableSortLabel, {
          id: column.id,
          classes: {
            root: s.disabled
          },
          active: false,
          hideSortIcon: true
        }, void 0, column.label), !column.disableSorting && !column.child && /*#__PURE__*/_jsx(TableSortLabel, {
          "data-test-id": "vHo1LEDDQL83vALFCONfr",
          id: column.id,
          active: !loading && orderBy === column.id,
          direction: order,
          classes: _objectSpread(_objectSpread({}, classesSortLabel), {}, {
            icon: classNames(classesSortLabel.icon, _defineProperty({}, s.hiddenSortIcon, loading || orderBy !== column.id))
          }),
          onClick: loading ? function () {
            return null;
          } : _.throttle(_this2.createSortHandler(column.id), 100)
        }, void 0, column.label), column.child)));
      }, this)));
    }
  }]);
  return EnhancedTableHead;
}(React.Component), _defineProperty(_class2, "defaultProps", {
  classNameHead: '',
  classesNameRow: {
    root: s.tableHeadRow
  },
  classesSortLabel: {},
  loading: false
}), _class2)) || _class) || _class);
export { EnhancedTableHead as default };